import { gql } from '@apollo/client';

export const CreateOfferFragment = gql`
  fragment CreateOfferFragment on OdProtosBuyerData_Offer {
    id
    ownAgent
    fundingSource
    mortgagePreapproval
    mortgageDownPaymentBps
    mortgageDownPaymentAmount
    price
    pricingAssistance
    offerState
  }
`;
